import { useEffect } from 'react'

// Nicked from https://stackoverflow.com/a/61127960
const useDebouncedEffect = (effect, deps, delay) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay)

    return () => clearTimeout(handler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps || [], delay])
}

export { useDebouncedEffect }



// WEBPACK FOOTER //
// ./src/hooks/useDebouncedEffect.js